import { useMutation } from '@tanstack/react-query'
import { notification } from 'antd'

import { axiosInstance } from '../../axios/axiosInstance'

export const useConfirmLandingStep = () =>
  useMutation(
    async ({ confirmData }) => {
      const { data } = await axiosInstance.post(
        `/api/auth/member/confirm`,
        confirmData,
      )
      return data
    },
    {
      onError: (err, { notificationKey }) => {
        if (err.response) {
          notification.error({
            ...(notificationKey ? { key: notificationKey } : {}),
            message:
              err?.response?.data?.message ||
              err?.message ||
              'Something went wrong. Please try again.',
          })
        }
      },
    },
  )
